import { AuthorizationAPIConfiguration } from '@sphere/platform';
import { CalendarAPIConfiguration } from 'nebula-apis/calendars';
import { CurveAPIConfiguration } from 'nebula-apis/curve';
import { CurveBuildRequestAPIConfiguration } from 'nebula-apis/curve-build';
import { CurveDefinitionAPIConfiguration } from 'nebula-apis/curve-definition';
import { CurveFolderAPIConfiguration } from 'nebula-apis/folders';
import { DataManagementAPIConfiguration } from 'nebula-apis/data-management';
import { UnitCurrencyAPIConfiguration } from 'nebula-apis/unit-currency';
import { DataSupportAPIConfiguration } from 'nebula-apis/data-support';
import { CurveSupportAPIConfiguration } from 'nebula-apis/curve-support';
import { PriceAlertAPIConfiguration } from 'nebula-apis/price-alerts';
import { KplerAPIConfiguration } from 'nebula-apis/kpler';
import { SphereAINewsAPIConfiguration } from '../../../feature-libs/instant-analyst-shared/src/lib/api/sphere-ai-instant-analyst/generated';
import { FormulaAPIConfiguration } from 'nebula-apis/curve-formula';
import { SettingsAPI } from '@sphere/platform';
import { WorkflowAPIConfiguration } from 'nebula-apis/workflow';
import { NotificationSubscriptionsAPIConfiguration } from 'nebula-apis/notification-subscriptions';
import { WorkspacesAPIConfiguration } from 'nebula-apis/workspaces';
import { SymbolSearchAPIConfiguration } from '../../../feature-libs/symbol-search/src/lib/shared/api/generated';
import { CredentialManagerAPIConfiguration } from '@sphere/platform';
import { NewsAPIConfiguration } from 'nebula-apis/news';

const apiConfigMap: { provideApiConfigurationClass: any; basePath: string }[] = [
    { provideApiConfigurationClass: AuthorizationAPIConfiguration, basePath: '/api/authorization' },
    { provideApiConfigurationClass: CalendarAPIConfiguration, basePath: '/api/calendar' },
    { provideApiConfigurationClass: CurveAPIConfiguration, basePath: '/api/curve' },
    { provideApiConfigurationClass: CurveBuildRequestAPIConfiguration, basePath: '/api/curvebuild' },
    { provideApiConfigurationClass: CurveDefinitionAPIConfiguration, basePath: '/api/curve-definition' },
    { provideApiConfigurationClass: CurveFolderAPIConfiguration, basePath: '/api/folder' },
    { provideApiConfigurationClass: FormulaAPIConfiguration, basePath: '/api/formula-builder' },
    { provideApiConfigurationClass: DataManagementAPIConfiguration, basePath: '/api/data-management' },
    { provideApiConfigurationClass: SettingsAPI.SettingsAPIConfiguration, basePath: '/api/setting' },
    { provideApiConfigurationClass: UnitCurrencyAPIConfiguration, basePath: '/api/unit-currency' },
    { provideApiConfigurationClass: WorkflowAPIConfiguration, basePath: '/api/workflow' },
    { provideApiConfigurationClass: DataSupportAPIConfiguration, basePath: '/api/data-support' },
    { provideApiConfigurationClass: CurveSupportAPIConfiguration, basePath: '/api/curve-support' },
    { provideApiConfigurationClass: NotificationSubscriptionsAPIConfiguration, basePath: '/api/notification' },
    { provideApiConfigurationClass: PriceAlertAPIConfiguration, basePath: '' },
    { provideApiConfigurationClass: KplerAPIConfiguration, basePath: '/api/kpler' },
    { provideApiConfigurationClass: WorkspacesAPIConfiguration, basePath: 'https://sphere-onb.enverus.com/api/workspace' },
    { provideApiConfigurationClass: NewsAPIConfiguration, basePath: '/api/news' },
    { provideApiConfigurationClass: SphereAINewsAPIConfiguration, basePath: '/api-nexus-2' },
    { provideApiConfigurationClass: SymbolSearchAPIConfiguration, basePath: '/api-nexus-2' },
    { provideApiConfigurationClass: CredentialManagerAPIConfiguration, basePath: '' }
];

export function provideGlobalApiConfiguration() {
    return apiConfigMap.map(({ provideApiConfigurationClass, basePath }) => ({
        provide: provideApiConfigurationClass,
        useValue: new provideApiConfigurationClass({ basePath })
    }));
}
